import { useTranslation } from "react-i18next";
import { Button, Flex } from "antd";
import Title from "antd/es/typography/Title";
import Paragraph from "antd/es/typography/Paragraph";
import { Link, useSearchParams } from "react-router-dom";
import * as Sentry from "@sentry/react";

const Error: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('eventId') || Sentry.lastEventId();
  const requestId = searchParams.get('requestId');

  return (
    <Flex data-testid="error" vertical align="center" className="h-screen pt-[115px] bg-[#E7F2FF]">
      <Flex vertical className="mt-[calc(243px-115px)]" gap={"24px"}>
        <Flex vertical gap={"8px"}>
          <Title className="text-center h1-bold text-o-title mt-[140px]">
            {t("Connection error occurred")}
          </Title>
          <Paragraph className="text-center body-regular text-o-description">
            {t("Please try again later or contact the brand.")}
          </Paragraph>
          {eventId && (
            <Paragraph className="text-center note-regular text-o-description">
              Error ID: {eventId}
            </Paragraph>
          )}
          {requestId && (
            <Paragraph className="text-center note-regular text-o-description">
              Request ID: {requestId}
            </Paragraph>
          )}
        </Flex>
        <Flex justify="center" gap={"12px"}>
          <Link to="line://">
            <Button
              className="rounded-[4px]"
              type="primary"
              ghost
              onClick={() => {
                window.close();
              }}
            >
              {t("Back to Line")}
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Error;
